import { __read, __spreadArray } from "tslib";
import { useMemo } from 'react';
import { SortOption, SortOrder } from '../models/SortOption';
export function useSortedDocuments(allDocs, pivot, sortOption, sortOrder) {
    var isMeetingPivot = pivot === 'meetings';
    var isSharedPivot = pivot === 'shared';
    var isRecentPivot = pivot === 'recent';
    return useMemo(function () {
        var clonedDocs = __spreadArray([], __read(allDocs), false);
        switch (sortOption) {
            case SortOption.Date:
                return clonedDocs.sort(function (item1, item2) {
                    var item1Date = isMeetingPivot
                        ? item1.createdDate
                        : isRecentPivot
                            ? item1.lastAccessedTime
                            : isSharedPivot
                                ? item1.lastSharedTime
                                : item1.lastActionTime;
                    var item2Date = isMeetingPivot
                        ? item2.createdDate
                        : isRecentPivot
                            ? item2.lastAccessedTime
                            : isSharedPivot
                                ? item2.lastSharedTime
                                : item2.lastActionTime;
                    if (item1Date === item2Date) {
                        return 0;
                    }
                    if (!item1Date) {
                        return 1;
                    }
                    if (!item2Date) {
                        return -1;
                    }
                    return sortOrder === SortOrder.Ascending
                        ? item2Date > item1Date
                            ? -1
                            : 1
                        : item1Date > item2Date
                            ? -1
                            : 1;
                });
                break;
            case SortOption.Name:
                return clonedDocs.sort(function (item1, item2) {
                    var item1Name = item1.title.toLowerCase(), item2Name = item2.title.toLowerCase();
                    return sortOrder === SortOrder.Ascending
                        ? item1Name.localeCompare(item2Name)
                        : item2Name.localeCompare(item1Name);
                });
                break;
            case SortOption.Owner:
                return clonedDocs.sort(function (item1, item2) {
                    var item1Owner = isSharedPivot
                        ? item1.isShared
                            ? item1.sharedByUsername
                                ? item1.sharedByUsername.toLowerCase()
                                : null
                            : null
                        : item1.creatorName
                            ? item1.creatorName.toLowerCase()
                            : null;
                    var item2Owner = isSharedPivot
                        ? item2.isShared
                            ? item2.sharedByUsername
                                ? item2.sharedByUsername.toLowerCase()
                                : null
                            : null
                        : item2.creatorName
                            ? item2.creatorName.toLowerCase()
                            : null;
                    if (item1Owner === item2Owner) {
                        return 0;
                    }
                    if (!item1Owner) {
                        return sortOrder === SortOrder.Ascending ? 1 : -1;
                    }
                    if (!item2Owner) {
                        return sortOrder === SortOrder.Ascending ? -1 : 1;
                    }
                    return sortOrder === SortOrder.Ascending
                        ? item1Owner.localeCompare(item2Owner)
                        : item2Owner.localeCompare(item1Owner);
                });
        }
    }, [
        allDocs,
        isMeetingPivot,
        isRecentPivot,
        isSharedPivot,
        sortOption,
        sortOrder,
    ]);
}
//# sourceMappingURL=useSortedDocuments.js.map